import React from "react";
import QuoteItemRow from "./QuoteItemRow";
import { MAX_QUOTE_ITEMS } from "../../Helper/Cotizacion/mockProducts";

const QuoteItemsSection = ({ items, onChangeItem, onAddItem, onRemoveItem }) => {
	const atMax = items.length >= MAX_QUOTE_ITEMS;

	return (
		<section style={{ marginBottom: "24px" }}>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					flexWrap: "wrap",
					gap: "8px",
					marginBottom: "8px",
				}}
			>
				<div>
					<h5 style={{ marginBottom: "4px" }}>3. Productos y servicios</h5>
					<p style={{ marginBottom: 0, color: "#718096", fontSize: "13px" }}>
						Máximo 5 productos o servicios por cotización.
					</p>
				</div>
				<button
					type="button"
					className="button primary"
					style={{ marginBottom: 0 }}
					onClick={onAddItem}
					disabled={atMax}
				>
					Agregar producto o servicio
				</button>
			</div>

			{items.length === 0 ? (
				<div
					style={{
						padding: "16px",
						border: "1px dashed #cbd5e0",
						borderRadius: "8px",
						color: "#718096",
					}}
				>
					Aún no hay productos. Agrega al menos uno para emitir la cotización.
				</div>
			) : (
				items.map((item, index) => (
					<QuoteItemRow
						key={item.id}
						item={item}
						index={index}
						onChange={onChangeItem}
						onRemove={onRemoveItem}
					/>
				))
			)}
		</section>
	);
};

export default QuoteItemsSection;
